import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83e04d1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-container" }
const _hoisted_2 = {
  key: 0,
  class: "atom-spinner"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner-line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "spinner-line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "spinner-line" }),
  /*#__PURE__*/_createElementVNode("div", { class: "spinner-circle" }, "●")
], -1))
const _hoisted_4 = [
  _hoisted_3
]

import Sidebar from "@/components/Sidebar.vue";
import User from "@models/User";
import { computed, ref, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

declare global {
  interface Window {
    jivo_onMessageSent: () => void;
    jivo_api: {
      setCustomData: (data: Array<{ key: string; content: string }>) => void;
    };
  }
}

// Get user data from store

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthenticatedLayout',
  setup(__props) {

const route = useRoute();
const store = useStore();
const showLoaderDelayed = ref(false);
let loaderTimeout: NodeJS.Timeout | null = null;

// Watch the store's showLoader state
watch(
  () => store.state.showLoader,
  (newValue) => {
    if (newValue) {
      // Set a timeout before showing the loader
      loaderTimeout = setTimeout(() => {
        showLoaderDelayed.value = true;
      }, 250); // Only show loader if loading takes more than 250ms
    } else {
      // Clear timeout if loading finishes quickly
      if (loaderTimeout) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;
      }
      showLoaderDelayed.value = false;
    }
  }
);

const sidebarRoutes = [
  "Dashboard",
  "MyJobs",
  "TaskBoard",
  "Profile",
  "CreateApplication",
  "Application",
  "NewDocument",
  "ExistingDocument",
  "EditResume",
  "InterviewPrep",
  "EmailGenerator",
  "MatchAnalysis",
  "Stats",
  "Feedback",
  "VoiceAssistant",
  "InterviewPractice",
  "InterviewAnalysis",
  "Resumes",
  "AIResumeEditorWithResume",
  "AIResumeEditorWithoutResume",
  "NewAIResume",
  "CoverLetters",
  "CoverLetterGenerator",
  "InterviewPractice",
  "InterviewAnalysis",
  "Resumes",
  "AIResumeEditorWithResume",
  "AIResumeEditorWithoutResume",
  "NewAIResume",
  "InterviewPracticeSelector"
];

const showSidebar = computed(() => {
  return sidebarRoutes.includes(route.name as string);
});

// Declare the Jivo callback function globally
const sendUserDataToJivo = () => {
  const user = store.state.user.user as User;
  if (!user) {
    console.log("No user found");
    return;
  }
  const userData = [
    { key: "name", content: `${user.name}` },
    { key: "email", content: user.email || "" },
    { key: "id", content: user._id?.toString() || "" },
    { key: "plan", content: user.subscriptionPlan },
    { key: "customerId", content: user.customerId },
  ];

  window.jivo_api.setContactInfo({
    name: `${user.name}`,
    email: user.email || "",
  });
  window.jivo_api.setCustomData(userData);
};

// Set up the Jivo callback
onMounted(() => {
  window.jivo_onMessageSent = () => {
    console.log("Client sent the first message");
    sendUserDataToJivo();
  };
});

function jivo_onMessageSent() {
  console.log("Message sent");
}

function jivo_onOpen() {
  console.log("Jivo chat opened");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showSidebar.value)
      ? (_openBlock(), _createBlock(Sidebar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", {
      class: _normalizeClass({
        'with-sidebar': showSidebar.value,
        'height-full-sidebar': _unref(route).name !== 'NewDocument' && _unref(route).name !== 'ExistingDocument' && _unref(route).name !== 'CoverLetterGenerator',
        loading: showLoaderDelayed.value,
      })
    }, [
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (showLoaderDelayed.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ], 2)
  ]))
}
}

})